import { Pipe, PipeTransform } from '@angular/core';
import { Status } from '../../enums/user-status';

@Pipe({
  name: 'userStatus',
  standalone: true,
})
export class UserStatusPipe implements PipeTransform {
  GREEN = [Status.ACTIVE];
  YELLOW = [Status.PENDING];
  RED = [Status.INACTIVE, Status.CANCELLED];
  BLACK = [Status.EXPIRED];
  BLUE = [Status.DRAFT];

  transform(value: any): string {
    if (this.GREEN.includes(value?.toLowerCase())) {
      return 'bg-success-500';
    } else if (this.YELLOW.includes(value?.toLowerCase())) {
      return 'bg-warning-500';
    } else if (this.RED.includes(value?.toLowerCase())) {
      return 'bg-destructive-500';
    } else if (this.BLACK.includes(value?.toLowerCase())) {
      return 'bg-neutral-900';
    } else if (this.BLUE.includes(value?.toLowerCase())) {
      return 'bg-primary-500';
    }
    return '';
  }
}
